import React from "react";
import logo from "./../assets/logo-dark.jpg";
import { Facebook, Instagram, MapPinHouse, Twitter, Youtube } from "lucide-react";
import app from "./../assets/app-store.svg";
import store from "./../assets/google-play.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img src={logo} alt="Wave Tech Services" className="w-20 h-auto" />
          </div>

          {/* Grid Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 w-full">
            {/* Quick Links */}
            <div className="space-y-3">
              <h2 className="font-bold text-lg">Quick Links</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                    Services
                  </Link>
                </li>
              </ul>
            </div>

            {/* For Customers */}
            <div className="space-y-3">
              <h2 className="font-bold text-lg">For Customers</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/contact_us" className="text-gray-300 hover:text-white transition-colors">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/about_us" className="text-gray-300 hover:text-white transition-colors">
                    About Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Our Policies */}
            <div className="space-y-3">
              <h2 className="font-bold text-lg">Our Policies</h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/disclaimer" className="text-gray-300 hover:text-white transition-colors">
                    Disclaimer
                  </Link>
                </li>
              </ul>
            </div>

            {/* Follow Us */}
            <div className="space-y-3 col-span-2 md:col-span-1">
              <h2 className="font-bold text-lg">Follow Us</h2>
              <div className="flex flex-wrap gap-3 mt-3">
                <a href="https://www.facebook.com/profile.php?id=61558010485353" className="bg-white p-2 rounded-full hover:-translate-y-1 transition-transform duration-300">
                  <Facebook className="text-black w-5 h-5" />
                </a>
                <a href="https://www.youtube.com/@WavetechServices13" className="bg-white p-2 rounded-full hover:-translate-y-1 transition-transform duration-300">
                  <Youtube className="text-black w-5 h-5" />
                </a>
                <a href="https://g.co/kgs/HWnDJGm" className="bg-white p-2 rounded-full hover:-translate-y-1 transition-transform duration-300">
                  <MapPinHouse className="text-black w-5 h-5" />
                </a>
                <a href="https://www.instagram.com/wavetechservices_/" className="bg-white p-2 rounded-full hover:-translate-y-1 transition-transform duration-300">
                  <Instagram className="text-black w-5 h-5" />
                </a>
              </div>
            </div>

            {/* App Stores */}
            <div className="space-y-3 col-span-2 md:col-span-1">
              <h2 className="font-bold text-lg">Download App</h2>
              <div className="flex flex-col sm:flex-row gap-3">
                <a href="https://play.google.com/store/apps/developer?id=Wave+Tech+Service" className="inline-block" target="_blank">
                  <img src={store} alt="Google Play" className="h-12 w-auto hover:scale-105 transition-transform duration-300" />
                </a>
                <a href="#" className="inline-block">
                  <img src={app} alt="App Store" className="h-12 w-auto hover:scale-105 transition-transform duration-300" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-gray-300 text-sm">
            © Copyright 2025 <span className="font-semibold">Wave Tech Services</span>. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;